import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';

import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { WINDOW_PROVIDERS } from './shared/services/window.service';
import { ClipboardModule } from 'ngx-clipboard';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FeaturesModule } from './features/features.module';
import { QuillModule } from 'ngx-quill';
import { quillToolbarConfig } from './shared/configs/quill-config';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';

var firebaseConfig = {
    apiKey: 'YOUR_API_KEY', //YOUR_API_KEY
    authDomain: 'YOUR_AUTH_DOMAIN', //YOUR_AUTH_DOMAIN
    databaseURL: 'YOUR_DATABASE_URL', //YOUR_DATABASE_URL
    projectId: 'YOUR_PROJECT_ID', //YOUR_PROJECT_ID
    storageBucket: 'YOUR_STORAGE_BUCKET', //YOUR_STORAGE_BUCKET
    messagingSenderId: 'YOUR_MESSAGING_SENDER_ID', //YOUR_MESSAGING_SENDER_ID
    appId: 'YOUR_APP_ID', //YOUR_APP_ID
    measurementId: 'YOUR_MEASUREMENT_ID', //YOUR_MEASUREMENT_ID
};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    wheelPropagation: false,
};

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent, FullLayoutComponent, ContentLayoutComponent],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        HttpClientModule,
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireAuthModule,
        NgbModule,
        ToastrModule.forRoot({ timeOut: 3000,
            positionClass: 'toast-top-full-width',
            preventDuplicates: true}),
        NgxSpinnerModule,
        ClipboardModule,
        QuillModule.forRoot({
            modules: {
                toolbar: quillToolbarConfig,
            },
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        AgmCoreModule.forRoot({
            apiKey: 'YOUR_GOOGLE_MAP_API_KEY',
        }),
        PerfectScrollbarModule,
        StoreModule.forRoot({}, {}),
        EffectsModule.forRoot([]),
        FeaturesModule,
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    ],
    providers: [
        { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
        WINDOW_PROVIDERS,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
